import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { TranslationLocale } from '../../../lib/types/enums/translation/translation.enum'
import { TripPlacesInput } from '../../../lib/types/models/trip-places/trip-places-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createTranslationsSchema } from '../../../lib/utils/validations/translations-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form } from '../../elements/forms/form'
import TranslationsInput from '../../elements/inputs/translations-input'
import ValidationButtons from '../../elements/validation-buttons'

type Props = BaseFormProps<TripPlacesInput> & {
  className?: string
}

const formSchema: ZodType<TripPlacesInput> = z.object({
  translations: createTranslationsSchema([TranslationLocale.FR])
})

const TripPlacesForm = ({ className, defaultValues, ...validationButtonProps }: Props) => {
  const form = useForm<TripPlacesInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={className}>
          <TranslationsInput
            control={form.control}
            name="translations"
            label="NOM"
            requiredLocales={[TranslationLocale.FR]}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default TripPlacesForm
